<template>
  <div class="Rule">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Rule",
  props: {
  },
  computed: {
  }
}
</script>

<style scoped>
.Rule {
  margin: 30px 30px 0;
  padding-left: 25px;
  font-size: 12px;
  color: #EF2562;
  background-image: url(../assets/Png/Common/Attention_Red.png);
  background-size: 1.4em;
}
</style>
